
import React, {useEffect, useState} from 'react';


import {connect} from 'react-redux';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {customcreartuvj1_676339f09ccea34376cf813a } from '../../api/formulariocontactanos3lmag.api'

import './contratapcghx.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Pcontratapcghx = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {


useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);


  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6756f3331de4874021c19c20" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
      <div id="itmdc" className="">
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <span>Inicio</span>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iwu1w"
        href="/sobrenosotros"
        type="button"
      >
        
    <div id="ib1qi" className="">
    <span>Sobre Nosotros</span>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i31ek"
        href="/servicios"
        type="button"
      >
        
    <div id="ipu5h" className="">
    <span>Servicios</span>
    </div>
    
      </a>
      
      </div>
      
      <div
        id="i207kz"
        className=""
        data-aos="zoom-in-down"
        data-aos-duration="2000"
      >
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4afizry.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iacot" className="">
      
      <a
        target=""
        className=""
        id="i2hsg"
        href="/contrata"
        type="button"
      >
        
    <div id="ij3vk" className="">
    <span>Contrata</span>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="im06bc"
        href="/contacto"
        type="button"
      >
        
    <div id="ifflju" className="">
    <span>Contacto</span>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ixxmu"
        href="/proveedores"
        type="button"
      >
        
    <div id="ikc1x" className="">
    <span>Proveedores</span>
    </div>
    
      </a>
      
      </div>
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <span>Inicio</span>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <span>Sobre Nosotros</span>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/servicios"
        type=""
      >
        <span>Servicios</span>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contrata"
        type=""
      >
        <span>Contrata</span>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contacto"
        type=""
      >
        <span>Contacto</span>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/proveedores"
        type=""
      >
        <span>Proveedores</span>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i17hyw" className="">
      
      </div>
      
      <div
        id="im0ja5"
        className=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
      
      <div id="iz8mng" className="">
      
      <div id="io8y2k" className="">
      
      <div id="iuhg3b" className="">
      
    <div id="i4z4a8" className="">
    
    </div>
    
      <p className="" id="i4kgfg">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ief5tk">
        <span>Conoce todos nuestros servicios </span>
      </span>
      
      </p>
      
      </div>
      
      <p className="" id="ixk7il">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="iouuyk">
        <span>CONTRATA</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iulme2" className="">
      
      <div
        id="i10vsv"
        className=""
        data-aos="zoom-in-left"
        data-aos-duration="750"
      >
      
      <div id="ik428w" className="">
      
      <div id="izsown" className="">
      
      </div>
      
      <p className="" id="iwtc3d">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ibdcss">
        <span>CONTRATA LO MEJOR</span>
      </span>
      
      </p>
      
      </div>
      
      <div
        id="i2qi5n"
        className=""
        data-aos="zoom-in-right"
        data-aos-duration="750"
      >
      
      <div id="i8ue6s" className="">
      
      <p className="" id="i1ipqh">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i0c86y">
        <span>Para tu evento especial, seleccionamos proveedores de máxima calidad, garantizando la excelencia en cada detalle y reflejando el compromiso de Ineven con experiencias inolvidables.</span>
      </span>
      
      </p>
      
      <p className="" id="if9e7o">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="idwjqd">
        <span>Encuentra lo mejor aquí</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ima16j" className="">
      
      </div>
      
      <div id="iot54w" className="">
      
      <div id="ieh8jv" className="">
      
      <p className="" id="ichjdv">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="it2qhu">
        <span>Explora nuestros proveedores</span>
      </span>
      
      </p>
      
      <p className="" id="id4puk">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ipiy0f">
        <span>Encuentra el mejor proveedor para ti </span>
      </span>
      
      </p>
      
      <div id="i79h3v" className="">
      
        <LoftyDropdownComponent
          id="izo0js"
          className=""
          childrenShow={
            <>
              <div id="i1ze3i" className="gjs-dropdown-menu-trigger ">
<span>Busca un proveedor</span></div>

            </>
          }
          childrenHover={
            <>
              <div id="i8fnye" className="gjs-dropdown-menu-content " style={{display: 'block'}}>
</div>

            </>
          }
        />
        
        <LoftyDropdownComponent
          id="iz6xmi"
          className=""
          childrenShow={
            <>
              <div id="i4d502" className="gjs-dropdown-menu-trigger ">
<span>Categorias</span></div>

            </>
          }
          childrenHover={
            <>
              <div id="il76rv" className="gjs-dropdown-menu-content " style={{display: 'block'}}>
</div>

            </>
          }
        />
        
      </div>
      
      </div>
      
      </div>
      
      <div id="ir0ke2" className="">
      
      </div>
      
      <div
        id="i8zcop"
        className=""
        data-aos="zoom-in-left"
        data-aos-duration="2000"
      >
      
      <div id="i355i7" className="">
      
      <p className="" id="ipfk2k">
        <span>EVENTOS GENERALES</span>
      </p>
      
      </div>
      
      </div>
      
      <div id="ib3hnn" className="">
      
      </div>
      
      <div
        id="i19sg1"
        className=""
        data-aos="zoom-in-right"
        data-aos-duration="2000"
      >
      
      <div id="ihfun9" className="">
      
      <p className="" id="i4n80a">
        <span>Planificación de eventos</span>
      </p>
      
      </div>
      
      </div>
      
      <div id="iez7pj" className="">
      
      </div>
      
      <div
        id="ieppuy"
        className=""
        data-aos="fade-left"
        data-aos-duration="2000"
      >
      
      <div id="i6imkh" className="">
      
      <p className="" id="iv56lf">
        <span>Catering y Banquetes</span>
      </p>
      
      </div>
      
      </div>
      
      <div id="ic9hb6" className="">
      
      </div>
      
      <div
        id="i064cn"
        className=""
        data-aos="zoom-in-right"
        data-aos-duration="2000"
      >
      
      <div id="ikbxs4" className="">
      
      <p className="" id="iye6zj">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ia8rkl">
        <span>Alquiler de Equipos y Mobiliario</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      <div id="ij188g" className="">
      
      </div>
      
      <div
        id="iuoorr"
        className=""
        data-aos="zoom-in-left"
        data-aos-duration="2000"
      >
      
      <div id="in5y1a" className="">
      
      <p className="" id="id2oij">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ioz0le">
        <span>Producción Audiovisual</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      <div id="iavhwg" className="">
      
      </div>
      
      <div
        id="im1kss"
        className=""
        data-aos="zoom-in-right"
        data-aos-duration="2000"
      >
      
      <div id="ibezy2" className="">
      
      <p className="" id="iiwltr">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="izktc3">
        <span>Entretenimiento</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      <div id="ir07mp" className="">
      
      </div>
      
      <div
        id="i2x4el"
        className=""
        data-aos="zoom-in-left"
        data-aos-duration="2000"
      >
      
      <div id="ifqorx" className="">
      
      <p className="" id="ic7o0i">
        <span>DISEÑO Y COMUNICACIÓN</span>
      </p>
      
      </div>
      
      </div>
      
      <div id="i58w1f" className="">
      
      </div>
      
      <div
        id="i57qno"
        className=""
        data-aos="zoom-in-right"
        data-aos-duration="2000"
      >
      
      <div id="idvzxr" className="">
      
      <p className="" id="ig7ars">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i1katp">
        <span>Diseño Gráfico y Publicidad</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      <div id="ikafsq" className="">
      
      </div>
      
      <div
        id="iaeu9f"
        className=""
        data-aos="zoom-in-left"
        data-aos-duration="2000"
      >
      
      <div id="i37hei" className="">
      
      <p className="" id="iwr1iq">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ia6zrc">
        <span>Transporte y Logística</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      <div id="irw94b" className="">
      
      </div>
      
      <div id="i3537n" className="">
      
      <p className="" id="iqzb9e">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ii01ij">
        <span>Alquiler de Vehículos y Transporte</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="io5kdi" className="">
      
      </div>
      
      <div id="i3wfwq" className="">
      
      <p className="" id="irayn8">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i6argz">
        <span>Logística y Transporte de Carga</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="ihwk3k" className="">
      
      </div>
      
      <div id="iu780s" className="">
      
      <p className="" id="is7uck">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ik6epo">
        <span>Estética y Registro Visual</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="id0pqj" className="">
      
      </div>
      
      <div id="iem6qs" className="">
      
      <p className="" id="ijfnsl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ikr3oj">
        <span>Decoración y Ambientación</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="i4iqo7" className="">
      
      </div>
      
      <div id="iwvwzj" className="">
      
      <p className="" id="ipgul4">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iwwjlg">
        <span>Fotografía y Videografía</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="iry0ip" className="">
      
      </div>
      
      <div id="icwk56" className="">
      
      <p className="" id="iso3c4">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i5pipf">
        <span>Maquillaje y preparación fisica</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="ic9cgp" className="">
      
      </div>
      
      <div id="ikpi6e" className="">
      
      <p className="" id="i02b1w">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="itfuhl">
        <span>Seguridad y Bienestar</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="isme38" className="">
      
      </div>
      
      <div id="ipdx7f" className="">
      
      <p className="" id="iv8s8j">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i3wsto">
        <span>Seguridad y Control de Multitudes</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="ijfiag" className="">
      
      </div>
      
      <div id="iwxnhl" className="">
      
      <p className="" id="ii3tb4">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="il6hfo">
        <span>Servicios de Salud y Bienestar</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="i7jqma" className="">
      
      </div>
      
      <div id="inhg0f" className="">
      
      <p className="" id="iwq25v">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="idq4k6">
        <span>Bodas y Celebraciones Especiales</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="i5t8po" className="">
      
      </div>
      
      <div id="iydyik" className="">
      
      <p className="" id="ion85e">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i8sj82">
        <span>Regalos y Souvenirs</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="i1920o" className="">
      
      </div>
      
      <div id="izko79" className="">
      
      <p className="" id="ih56mq">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i22vf8">
        <span>Coordinación especializada en bodas</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="i8xgqe" className="">
      
      </div>
      
      <div id="ihr6j2" className="">
      
      <p className="" id="i5u2qk">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ik6yaf">
        <span>Bodas y Celebraciones Especiales</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="ixwthn" className="">
      
      </div>
      
      <div id="ik2yll" className="">
      
      <p className="" id="iduqf3">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iq62j7">
        <span>Formación y Talleres</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="i6bywk" className="">
      
      </div>
      
      <div id="imrilf" className="">
      
      <p className="" id="ixd7bp">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="it72g6">
        <span>Finanzas y Patrocinio</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="ia16px" className="">
      
      </div>
      
      <div id="i9goi1" className="">
      
      <div id="ip0qxf" className="">
      
      <div id="i68cuj" className="">
      
      <p className="" id="iszk86">
        
      <span className="" id="iw7wzt">
        <span>Comienza tu Historia con Ineven</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="i0s6tp" className="">
      
      <div id="iimphx" className="">
      
      <p className="" id="ids9we">
        
      <span className="" id="iofwwf">
        <span>¡Estamos emocionados por unirnos a ti en esta historia creativa!.</span>
      </span>
      
      </p>
      
      <p className="" id="i6p7lb">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ia7jlg">
        <span>Estamos emocionados por unirnos a ti en este viaje creativo.</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="icl0bc" className="">
      
      <p className="" id="irk6nw">
        
      <span className="" id="iiplmf">
        <span>Cuéntanos tus ideas</span>
      </span>
      
      </p>
      
      <p className="" id="iu4rfo">
        <span>Cuéntanos tus ideas</span>
      </p>
      
      <div id="icbmav" className="">
      <span>Ingresa tus datos</span>
      </div>
      
        <div className="" id="i7kqii">
          
      <form
        id="it1515"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await customcreartuvj1_676339f09ccea34376cf813a({
						nombreo31bw: e.target.nombreo31bw.value,
						telefono71bhf: e.target.telefono71bhf.value,
						correov6gp1l: e.target.correov6gp1l.value,
						cuentanostuideakfptok: e.target.cuentanostuideakfptok.value,
					});
					alert("Se agregó exitosamente");
		} catch (error) {
					console.log(error);
				}
			}}
		
      >
        
      <div id="irwz0a" className="">
      
      <br className="" id="" />
      
      <input
        name="nombreo31bw"
        type="text"
        placeholder="Nombre"
        className="camposFormulario "
        id="ibpr3t"
      />
      
      </div>
      
      <div id="iygiwv" className="">
      
      <br className="" id="" />
      
      <input
        name="telefono71bhf"
        type="text"
        placeholder="Telefono"
        className="camposFormulario "
        id="ibq2ju"
      />
      
      </div>
      
      <div id="i0aqbv" className="">
      
      <br className="" id="" />
      
      <input
        name="correov6gp1l"
        type="text"
        placeholder="Correo"
        className="camposFormulario "
        id="i49axl"
      />
      
      </div>
      
      <div id="i2n2nd" className="">
      
      <br className="" id="" />
      
      <input
        name="cuentanostuideakfptok"
        type="text"
        placeholder="Cuentanos tu Idea"
        className="camposFormulario "
        id="iksa0c"
      />
      
      </div>
      
      <button
        type="submit"
        name=""
        id="ire21e"
        className=""
        
      >
      
      <div id="iv7a8f" className="">
      <span>Enviar</span>
      <br className="" id="" />
      
      </div>
      
      </button>
      
      </form>
      
        </div>
        
      <div id="iym77j" className="">
      
      <p className="" id="iynyxj">
        
      <span className="" id="ikcb1k">
        <span>¿Eres proveedor?</span>
      </span>
      
      </p>
      
        <a
          target=""
          className=""
          id="iowpze"
          href="#"
        >
          
    <div id="ioqyiy" className="">
    
      <span className="" id="ig5j4r">
        <span>Encuentra</span>
      </span>
      
    </div>
    
        </a>
        
      <p className="" id="iebja3">
        
      <span className="" id="ii5d7c">
        <span>nuevos clientes</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ir2czw" className="">
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <img
        className=""
        id="imi9j3"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4afizry.png"
        alt="undefined"
      />
      
      <p className="" id="iyo7r6">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="il8o0q">
        <span>Ingenieria de eventos.</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="id3akf" className="">
      
      <div id="ipwalf" className="">
      
      <img
        className=""
        id="icnrzk"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4vijr82.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className=""
          id="iqw2cc"
          href="https://www.tiktok.com/@ineven.vip?_t=8sKdB0x1PBG&_r=1"
        >
          
    <div id="ii8s3v" className="">
    <span>ineven.vip</span>
      <br className="" id="" />
      
    </div>
    
        </a>
        
      </div>
      
      <div id="i74eju" className="">
      
      <img
        className=""
        id="ieessu"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4bmczdi.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className=""
          id="ic971i"
          href="https://www.facebook.com/ineven.vip"
        >
          
    <div id="ipkyyf" className="">
    <span>ineven.vip</span>
      <br className="" id="" />
      
    </div>
    
        </a>
        
      </div>
      
      <div id="igk236" className="">
      
      <img
        className=""
        id="i9z0pd"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4bmd43v.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className=""
          id="ijat25"
          href="https://www.instagram.com/ineven.vip?igsh=b25xZHA5MDVqaDVp"
        >
          
    <div id="itqytu" className="">
    <span>@ineven.vip</span>
      <br className="" id="" />
      
    </div>
    
        </a>
        
      </div>
      
      <div id="io5w49" className="">
      
      <img
        className=""
        id="i6uigw"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4viijg2.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className=""
          id="ihyk4h"
          href="https://www.linkedin.com/company/ineven/"
        >
          
    <div id="ijzppm" className="">
    <span>ineven.vip</span>
      <br className="" id="" />
      
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="i1rlot" className="">
      
      <p className="" id="iw7za7">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ic71jf">
        
      <a
        target=""
        className=""
        id="ic44ai"
        href="/sobrenosotros"
        type=""
      >
        <span>Sobre nosotros</span>
      </a>
      
      </span>
      
      </p>
      
      <p className="" id="i3340b">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ih08ak">
        
      <a
        target=""
        className=""
        id="i6vm75"
        href="/servicios"
        type=""
      >
        <span>Nuestros servicios</span>
      </a>
      
      </span>
      
      </p>
      
      <p className="" id="ijqtal">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="itkfgw">
        
      <a
        target=""
        className=""
        id="iklrtj"
        href="/contrata"
        type=""
      >
        <span>Hazlo tú mismo</span>
      </a>
      
      </span>
      
      </p>
      
      <p className="" id="ik2e3t">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="it8v73">
        
      <a
        target=""
        className=""
        id="iku0nj"
        href="/proveedores"
        type=""
      >
        <span>Testimonio</span>
      </a>
      
      </span>
      
      </p>
      
      <p className="" id="i38bqt">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ib7tnq">
        
      <a
        target=""
        className=""
        id="itchax"
        href="/contacto"
        type=""
      >
        <span>Contáctanos</span>
      </a>
      
      </span>
      
      </p>
      
      </div>
      
      <div id="ipuzkj" className="">
      
      <p className="" id="ifh7p5">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ita68z">
        <span>+504 9574-8270</span>
      </span>
      
      </p>
      
      <p className="" id="i78qcc">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="imjhna">
        <span>Col. Colonia, 7 calle, 8 avenida S.O</span>
      </span>
      
      </p>
      
      <p className="" id="il1rnw">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i6f3bu">
        <span>ingenierodeevento@gmail.com</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      <div id="iou1pv" className="">
      
      <p className="" id="izq2dp">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ieap6m">
        <span>Todos los derechos reservados - Ineven - 2022 </span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pcontratapcghx);
  